import { render, staticRenderFns } from "./ModelHotel.vue?vue&type=template&id=e99a6010&"
import script from "./ModelHotel.vue?vue&type=script&lang=js&"
export * from "./ModelHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports